module.exports = __webpack_public_path__ + "media/08_ASANBUDAPEST-Vibes08.656bd6cc.mp3";